export const hideSidebar = () => {
    const rightSideBarMain = document.getElementById('right-side-bar-main');
    if (rightSideBarMain) {
        rightSideBarMain.style.display = 'none';
    }
};

export const showSidebar = () => {
    const rightSideBarMain = document.getElementById('right-side-bar-main');
    if (rightSideBarMain) {
        rightSideBarMain.style.display = '';
    }
};
